import React, { useEffect } from "react";
import { FaUserShield } from "react-icons/fa";
import { withTranslation } from "react-i18next";

import "./PlatformAccessPlaceholder.css";

function PlatformAccessPlaceholder({ t }) {
  useEffect(() => {
    document.title = "Agriconnected - Cadastro de Administradores";
  }, []);

  return (
    <div className="platform-access-placeholder">
      <div className="x_title">
        <h2>
          <FaUserShield style={{ marginRight: 10 }} />
          {t("Cadastro de Administradores")}
        </h2>
        <div className="clearfix" />
      </div>

      <div className="platform-access-placeholder__card">
        <span className="platform-access-placeholder__badge">
          {t("Em breve")}
        </span>

        <p className="platform-access-placeholder__lead">
          {t(
            "Aqui será o cadastro de quem pode acessar a plataforma web, com perfis, grupos e histórico de ações."
          )}
        </p>

        <h3>{t("O que está planejado")}</h3>
        <ul className="platform-access-placeholder__list">
          <li>
            {t(
              "Perfis de acesso (Gestor, Agrônomo, Visualizador) com permissões configuráveis"
            )}
          </li>
          <li>
            {t(
              "Grupos de máquinas e operadores — cada usuário vê e envia ordens só para o que foi liberado"
            )}
          </li>
          <li>
            {t(
              "Indicador de quem está online e data/hora do último acesso"
            )}
          </li>
          <li>
            {t(
              "Historian — registro de quem criou ou alterou ordens de serviço e recomendações"
            )}
          </li>
        </ul>

        <p className="platform-access-placeholder__note">
          {t(
            "Por enquanto, use Cadastros → este menu como referência. O convite de administradores continua disponível no menu do usuário (Administradores)."
          )}
        </p>
      </div>
    </div>
  );
}

export default withTranslation()(PlatformAccessPlaceholder);
